import * as React from "react";
const SvgCheckbox = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 17, height: 17, x: 0.5, y: 0.5, fill: "#fff", stroke: "currentColor", rx: 1.5 }));
export default SvgCheckbox;
